<script setup lang="ts">
import { StallArea, type StallData } from '~/lib/stall';

interface Props {
  data: StallData
  index: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click', value: MouseEvent): void
}>()
</script>

<template>
  <div :id="String(index + 1)" class="pb-2 w-full shadow hover:opacity-80 transition-opacity cursor-pointer shadow-gray-400 rounded overflow-hidden max-w-[400px]" @click="emit('click', $event)">
    <div 
      class="h-1.5 mb-3"
    />
    <div class="mr-1 p-0 grid grid-cols-[auto_1fr] gap-x-2 gap-y-0">
      <div class="row-span-2 grid place-items-center">
        <div 
          class="w-[100px] h-[60px] grid place-items-center text-white rounded-r"
          :style="{ 'background-color': StallArea[props.data['エリアID']].color }"
        >
          <span v-if="!props.data['場所']" class="text-4xl">
            {{ props.data["ID"] }}
          </span>
          <span v-if="props.data['場所']" class="text-2xl">
            {{ props.data["ID"] }}
          </span>
          <span v-if="props.data['場所']" class="text-sm">
            （{{ props.data["場所"] }}）
          </span>
        </div>
      </div>
      <h3 class="text-md flex flex-wrap justify-center gap-x-2 text-center">
        <span v-for="text in props.data['組織名'].split(';')">
          {{ text }}
        </span>
      </h3>
      <h2 class="text-xl flex flex-wrap justify-center gap-x-2 text-center">
        <span v-for="text in props.data['団体名'].split(';')">
          {{ text }}
        </span>
      </h2>
    </div>
    <div class="col-span-3 divider my-0" />
    <div class="mx-1 p-0 text-center text-2xl">
      <span v-for="text in props.data['販売品目'].split(';')">
          {{ text }}
        </span>
    </div>
  </div>
</template>
